import type { ReactNode } from "react";
import { config } from "../config";
import { Link } from "../router";
import { useSession } from "../session";

export function Layout({ children, wide = false }: { children: ReactNode; wide?: boolean }) {
  const { session, signOut } = useSession();
  const signedIn = session.status === "signed-in";

  return (
    <div className="page">
      <header className="topbar">
        <Link to="/" className="brand">
          <img src="/brand/frameflow-logo.svg" alt="FrameFlow" width="154" height="32" />
        </Link>
        {signedIn && (
          <button type="button" className="link-button" onClick={() => void signOut()}>
            יציאה
          </button>
        )}
      </header>
      <main className={wide ? "content content-wide" : "content"}>{children}</main>
      <footer className="footer">
        <a href={config.termsUrl} target="_blank" rel="noopener">
          תנאי שימוש
        </a>
        <span aria-hidden="true">·</span>
        <a href={config.privacyUrl} target="_blank" rel="noopener">
          מדיניות פרטיות
        </a>
        <span aria-hidden="true">·</span>
        <a href={config.marketingSiteUrl}>frame-flow.ai</a>
      </footer>
    </div>
  );
}

/** Centered card for the sign-up and sign-in pages. */
export function AuthCard({ title, subtitle, children }: { title: string; subtitle?: ReactNode; children: ReactNode }) {
  return (
    <section className="card auth-card">
      <h1>{title}</h1>
      {subtitle && <p className="subtitle">{subtitle}</p>}
      {children}
    </section>
  );
}

export function Loading() {
  return (
    <div className="loading" role="status">
      <span className="spinner" aria-hidden="true" />
      <span className="visually-hidden">טוען…</span>
    </div>
  );
}
